import { SCOPE } from "@/constants/scope";

// "Completed" is one user-facing concept spanning both terminal intake statuses
// (mirrors COMPLETED_STATUS_FILTER in IntakeTablePage, LAM-4305). Toggles read/write
// all raw keys of a group; storage and filtering stay on real statuses.
export const ACTION_NEEDED_OPTION_GROUPS = { [SCOPE.INTAKE]: { INTAKE_COMPLETE: ["INTAKE_COMPLETE", "SENT_TO_EHR"] } };

export function groupActionNeededOptions(scope, optionKeys) {
  const groups = ACTION_NEEDED_OPTION_GROUPS[scope] || {};
  const absorbed = new Set(
    Object.values(groups)
      .flat()
      .filter((key) => !(key in groups))
  );
  return (optionKeys || []).filter((key) => !absorbed.has(key)).map((key) => ({ key, keys: groups[key] || [key] }));
}
